<template>
  <div class="shadow-md">
    <div class="bg-white text-gray-800 font-semibold text-lg p-3 text-left">{{ infraItem.name }}</div>
    <div class="bg-gray-100">
      <img class="object-cover w-full h-96" :src="`/static/images/${dir}/infrastructure/${infraItem.image}.jpg`"
           alt="{{infraItem.name}}">
    </div>
  </div>
</template>

<script>

export default {
  name: "InfrastructureCard",
  props: {
    infraItem: Object,
    dir: String
  },

}
</script>

<style scoped>

</style>